import SellerApi from '../api/sellerApi';
import { createSellerError, createSellerSuccess, deleteSellerError, deleteSellerSuccess, fetchSellerByIdError,
    fetchSellerByIdSuccess, fetchSellersError, fetchSellersSuccess, updateSellerError, updateSellerSuccess }
    from '../reducers/sellerReducer';
import { put, takeLatest, call } from 'redux-saga/effects';
import Seller from '../interfaces/output/seller';
import Pagination from '../interfaces/common/pagination';
import Paging from '../interfaces/common/paging';
import { PayloadAction } from '@reduxjs/toolkit';
import HttpErrorResponse from '../interfaces/common/httpErrorResponse';

function* doFetchSeller(action: PayloadAction<string>) {
    const sellerId = action.payload;
    try {
        const response: Seller = yield call(SellerApi.fetchSellerById, sellerId);
        yield put(fetchSellerByIdSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchSellerByIdError(error as HttpErrorResponse));
    }
}

function* doFetchSellers(action: PayloadAction<{ paging: Paging }>) {
    const { paging } = action.payload;

    try {
        const response: Pagination<Seller> = yield call(SellerApi.fetchSellers, paging);
        yield put(fetchSellersSuccess(response));
    }

    catch (error: unknown) {
        yield put(fetchSellersError(error as HttpErrorResponse));
    }
}

function* doCreateSeller(action: PayloadAction<Seller>) {
    const seller = action.payload;

    try {
        const response: Seller = yield call(SellerApi.createSeller, seller);

        yield put(createSellerSuccess(response));
    }

    catch (error: unknown) {
        yield put(createSellerError(error as HttpErrorResponse));
    }
}

function* doUpdateSeller(action: PayloadAction<Seller>) {
    const seller = action.payload;

    try {
        const response: Seller = yield call(SellerApi.updateSeller, seller);

        yield put(updateSellerSuccess(response));
    }

    catch (error: unknown) {
        yield put(updateSellerError(error as HttpErrorResponse));
    }
}

function* doDeleteSeller(action: PayloadAction<number>) {
    const sellerId = action.payload;

    try {
        const response: Seller = yield call(SellerApi.deleteSeller, sellerId);

        yield put(deleteSellerSuccess(response));
    }

    catch (error: unknown) {
        yield put(deleteSellerError(error as HttpErrorResponse));
    }
}

export default [
    takeLatest('seller/fetchSellerById', doFetchSeller),
    takeLatest('seller/fetchSellers', doFetchSellers),
    takeLatest('seller/createSeller', doCreateSeller),
    takeLatest('seller/updateSeller', doUpdateSeller),
    takeLatest('seller/deleteSeller', doDeleteSeller)
];

